var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIssue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 124,
    rx: 62,
    fill: "#E5E5E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 53.25H59.5V48.25H64.5V53.25ZM64.5 64.5H59.5V59.5H64.5V64.5ZM64.5 75.75H59.5V70.75H64.5V75.75ZM87 57V47C87 45.6739 86.4732 44.4021 85.5355 43.4645C84.5979 42.5268 83.3261 42 82 42H42C40.6739 42 39.4021 42.5268 38.4645 43.4645C37.5268 44.4021 37 45.6739 37 47V57C38.3261 57 39.5979 57.5268 40.5355 58.4645C41.4732 59.4021 42 60.6739 42 62C42 63.3261 41.4732 64.5979 40.5355 65.5355C39.5979 66.4732 38.3261 67 37 67V77C37 78.3261 37.5268 79.5979 38.4645 80.5355C39.4021 81.4732 40.6739 82 42 82H82C83.3261 82 84.5979 81.4732 85.5355 80.5355C86.4732 79.5979 87 78.3261 87 77V67C85.6739 67 84.4021 66.4732 83.4645 65.5355C82.5268 64.5979 82 63.3261 82 62C82 60.6739 82.5268 59.4021 83.4645 58.4645C84.4021 57.5268 85.6739 57 87 57Z",
    fill: "#959BA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssue);
export default __webpack_public_path__ + "static/media/issue.d5a93310e3fba8e64a06560aabaada22.svg";
export { ForwardRef as ReactComponent };